import React, { Component } from "react";
import axios from 'axios';

// import ViewNavigationV2 from './ViewNavigationV2.js';
import ViewPanelV2 from './ViewPanelV2.js';

import * as Constants from "./Constants.js";

import Loader from 'react-loader-spinner';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";

const queryString = require('query-string');

class ViewV2 extends Component {
  
  constructor(props) {
    super(props);
    this.state = {
      brandTitle: "epilogos MEME",
      brandSubtitle: "perform motif discovery for chromatin state sequences",
      viewPanelKey: Date(),
      dataState: "loading",
      description: "",
      dataURL: "",
      textURL: "",
      xmlURL: "",
      archiveURL: "",
      metadataURL: "",
      uuid: "",
    }
    this.bottomHalfContainer = React.createRef();
  }
  
  componentDidMount() {
    let query = queryString.parse(window.location.search);
    if ('id' in query) {
      let self = this;
      console.log(`retrieving job for ID ${query.id}`);
      axios.post('../assets/services/retrieveJob.py', { id : query.id })
        .then(function(response) {
          let jobMetadata = response.data;
          console.log("jobMetadata", jobMetadata);
          let metadataURL = Constants.rootResultsURL + '/' + jobMetadata['id'] + '/job_metadata.json';
          let dataURL = Constants.rootResultsURL + '/' + jobMetadata['id'] + '/results/meme.html';
          let textURL = Constants.rootResultsURL + '/' + jobMetadata['id'] + '/results/meme.txt';
          let xmlURL = Constants.rootResultsURL + '/' + jobMetadata['id'] + '/results/meme.xml';
          let archiveURL = Constants.rootResultsURL + '/' + jobMetadata['id'] + '/results/epilogos-meme.' + jobMetadata['id'] + '.tbz2';
          console.log("dataURL", dataURL);
          //
          // check if meme.html exists (200); proceed load state data if so, else set view panel content to something else
          //
          var xhr = new XMLHttpRequest();
          xhr.open('HEAD', dataURL, true); // asynchronous
          xhr.onreadystatechange = function() {
            if (this.readyState === 4) {
              if (this.status === 200) {
                console.log("A1: this.readyState", this.readyState, this.status, self.state.dataState);
                self.setState({
                  uuid : jobMetadata['id'],
                  description : jobMetadata['description'],
                  dataState : "valid",
                  dataURL : dataURL,
                  textURL: textURL,
                  xmlURL: xmlURL,
                  archiveURL : archiveURL,
                  metadataURL : metadataURL,
                  viewPanelKey : Date(),
                }, () => {
                  console.log("A2: this.readyState", this.readyState, this.status, self.state.dataState);
                })
              }
              else {
                console.log("B: this.status", this.status);
                self.setState({
                  description : "",
                  dataState : "invalid",
                  viewPanelKey : Date()
                })
              }
            }
            else {
              console.log("this.readyState", this.readyState);
            }
          };
          xhr.send(null);
        })
        .catch(function(error) {
          console.log(error);
          if (error.response) {
            console.log(JSON.stringify(error.response.data));
            console.log(error.response.status);
            console.log(error.response.headers);
            switch (error.response.status) {
              case 400:
              case 403:
              case 404:
                self.setState({
                  description : "",
                  dataState : "invalid",
                  viewPanelKey : Date()
                })
                break;
              default:
                break;
            }
          }
        })
    }
    else {
/*
      console.log("Redirecting to front page...");
      window.location.href = Constants.rootURL;
*/
    }
  }

  render () {
    return (
      <div className="App">
        <div className="parent-container-navigation">
          {/*<ViewNavigationV2 
            key={this.state.navbarKey}
            brandTitle={this.state.brandTitle}
            brandSubtitle={this.state.brandSubtitle}
            description={this.state.description}
            archiveURL={this.state.archiveURL}
            uuid={this.state.uuid} />*/}
          {(this.state.dataState === 'loading') ? 
          <div className="center-div">
            <Loader
               type="Oval"
               color="#000000"
               height={100}
               width={100}               
              />
            <p style={{marginTop:"10px"}}>loading...</p>
          </div> :
          <div className="left-div">
            <ViewPanelV2
              key={this.state.viewPanelKey}
              uuid={this.state.uuid}
              description={this.state.description}
              dataState={this.state.dataState}
              dataURL={this.state.dataURL}
              textURL={this.state.textURL}
              xmlURL={this.state.xmlURL}
              archiveURL={this.state.archiveURL}
              metadataURL={this.state.metadataURL}
              />
          </div>}
        </div>
      </div>
    );
  }
}

export default ViewV2;